import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVetCategoryColorRectangle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "current",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("rect", {
		x: 3,
		y: 3,
		width: 14,
		height: 14,
		rx: 4,
		fill: "current"
	})]
});
const ForwardRef = forwardRef(SvgVetCategoryColorRectangle);
export { ForwardRef as ReactComponent };
